/**
 @ngdoc directive
 @name sectionProgress

 @description
 Draws bobbles hinting how much progress the user has done through all the  sections

 @usage
 <section-progress id="PLEASE_DEFINE_A_UNIQUE_ID"></section-progress>
 <section-progress id="section1of2IsThisDeveloperIsLazy" on="1" size="2"></section-progress>
 <section-progress id="section2of3IsThisDeveloperIsLazy" on="2" size="3"></section-progress>
 <section-progress id="section3of4IsThisDeveloperIsLazy" on="3" size="4"></section-progress>
 <section-progress id="section4of5IsThisDeveloperIsLazy" on="4" size="5"></section-progress>
 <section-progress id="section5of6IsThisDeveloperIsLazy" on="5" size="6" ></section-progress>
 <section-progress id="section2DangerOf4IsThisDeveloperIsLazy" on="2" size="4" state="popupForm.$valid ? 'SUCCESS' : 'DANGER'"></section-progress>
 <section-progress id="section2SuccessOf4IsThisDeveloperIsLazy" on="2" size="4" state="DANGER"></section-progress>
 <section-progress id="section2SuccessOf4IsThisDeveloperIsLazy" on="2" size="4" state="SUCCESS"></section-progress>
 <section-progress id="section2WarningOf4IsThisDeveloperIsLazy" on="2" size="4" state="WARNING"></section-progress>
 <section-progress id="section2InfoOf4IsThisDeveloperIsLazy" on="2" size="4" state="INFO"></section-progress>
 <section-progress id="section2NoneOf4IsThisDeveloperIsLazy" on="2" size="4" state="NONE"></section-progress>

 @param {string}    id               - Unique name
 @param {int}       size             - How many sections
 @param {int}       on               - What section are you on
 @param {function}  state            - What state that section is - use a function, expression or string that evaluates to a string value of options from SECTION_STATE
 */

(function() {
    'use strict';
    var sectionProgress = function ($templateCache) {
        return {
            restrict: 'E',
            bindToController: {
                id: "@",
                size: "@",
                on: "@",
                state: "&"
            },
            controllerAs: "ctrl",
            replace: true,
            scope: true,
            template: $templateCache.get('components/sectionProgress.html'),
            controller: function() {
                var _this = this;
                const SECTION_STATE = {
                    DANGER: 'DANGER', // incomplete
                    SUCCESS: 'SUCCESS', // complete
                    NONE: 'NONE', // to do
                    WARNING: 'WARNING', // somethings up but nothing serious
                    INFO: 'INFO' // information
                };
                _this.SECTION_STATE = SECTION_STATE;

                _this.$onInit = function() {
                    //console.log('sectionProgress',_this.id);
                    // Default to 5 sections if not specified
                    if(_this.size===undefined) _this.size = 5;
                    // Default to being on 1st section if not specified
                    if(_this.on===undefined)
                        _this.on = 1;
                    else
                        _this.on = parseInt(_this.on);

                    // Calculate percentage space
                    _this.percentage = Math.floor(100/_this.size);

                    _this.sections = [];
                    for(var i=1;i<=_this.size;i++){
                        _this.sections.push({
                            text: i,
                            on: (i===_this.on),
                            state: (i===_this.on) ? _this.state : (i<_this.on) ? getStateSuccess : getStateNone,
                        })
                    }
                };

                _this.getState = function(state){
                    // Default to being on incomplete, if not specified
                    if(state===undefined){
                        return SECTION_STATE.DANGER;
                    }else{
                        return SECTION_STATE[state];
                    }
                };

                // methods to allow us to call state() as a function from html template
                var getStateSuccess = function(){
                    return SECTION_STATE.SUCCESS;
                };

                var getStateNone = function(){
                    return SECTION_STATE.NONE;
                };
            }
        };
    };
    sectionProgress.$inject = ['$templateCache'];
    angular.module('app').directive('sectionProgress',sectionProgress);
}());